import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class ScoreFilter {
  public paging: PaginationRequest = new PaginationRequest()
}
